import { Link } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'

interface Props {
  to: string
  description: string
  cta: string
}

const RatesCallout = ({ to, cta, description }: Props) => {
  return (
    <Callout
      description={description}
      type="info"
      link={
        <Link.Router to={to} type="solid">
          {cta}
        </Link.Router>
      }
    />
  )
}

export default RatesCallout
